import { useEffect, useContext } from 'react';
// import { OnboardingDesktop } from './onboarding/Onboarding';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';
import { StartHere } from './StarHere';
import { CreativeBrief } from './campaign/CreativeBrief';
import { ProductPromoPage } from './campaign/PromoProduct';
import { CallRecording } from './campaign/CallRecording';
import { Contact } from './setup/Contacts';
import { SocialMedia } from './report/SocialMedia';
import { BankDetails } from './setup/BankDetails';
import { ProductReceived } from './sales/product/ProductReceived';
import { ProductPreparing } from './sales/product/ProductPreparing';
import { ProductShipped } from './sales/product/ProductShipped';
import { SalesProduct } from './report/sales/SalesProduct';
import { BookingPromoPage } from './campaign/PromoBooking';
import { BookingBooked } from './sales/booking/Booked';
import { BookingCheckIn } from './sales/booking/CheckIn';
import { SalesBooking } from './report/sales/SalesBooking';
import { SetupTraining } from './setup/SetupTraining';
import { PosterTraining } from './campaign/PosterTraining';
import { SalesTraining } from './sales/SalesTraining';
import { RealProperty } from './setup/RealProperty';
import { RequestedRealProperty } from './setup/RequestRealProperty';
import { PropertyInquiries } from './sales/realproperty/PropertyInquiries'; 
import { OnboardingSalesProduct } from './sales/onboarding/OnboardingSalesProduct';
import { OnboardingSalesBooking } from './sales/onboarding/OnboardingSalesBooking';
import { OnboardingSalesRealProperty } from './sales/onboarding/OnboardingSalesRealProperty';
// import { FeaturesTour } from './onboarding/FeaturesTour';
// import { useShowRealProperty } from '../../global/GlobalFunctions';

export const TourPersonalization = () => {
	const {tool_state, personalization_state} = useContext(ToolContext);
    const {__SESSION} = tool_state
    const {personalization, walkthrough, startHere/* , selected, toOpenBankForm */} = personalization_state
	// const fullURL = window.location.pathname + window.location.search
	// const showRP = useShowRealProperty()
	const user_id = parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]);
    const tool_id =  process.env.REACT_APP_TID_BIZ;

	const personalizationRead = async() =>{
        let prs = await rqx.get(`<<global>>/${env()}/personalization/read`, {user_id: user_id, tool_id:tool_id, ref:'all'})
        let map_arry = prs.map(v => {return {...v, personalization: JSON.parse(v.personalization)} } );
        personalization.set(map_arry);
    }

    // const start = (featureName, p_name, setter) =>{
    //     if (personalization?.data?.find(prs => prs.feature_name === featureName)){
    //         let prs = personalization?.data?.find(prs => prs.feature_name === featureName).personalization
    //         if (!prs.find(p=>p.p_name === p_name)){
    //             setter()
    //         }
    //     }else{
    //         setter()
    //     }
    // }

    const end = async(featureName, p_name) => {
		console.log('end function', featureName, p_name);
		// walkthrough.set((p) => ({...p, [p_name]: false }))
        let newPersonalization = []

        let prs = await rqx.get(`<<global>>/${env()}/personalization/read`, {user_id: user_id, tool_id:tool_id, ref:'all'})

        if (prs.find(prs => prs.feature_name === featureName)){
            let map_arry = prs.map(v => {return {...v, personalization: JSON.parse(v.personalization)} } );
            personalization.set(map_arry)
            newPersonalization = map_arry ? map_arry.find(prs => prs.feature_name === featureName).personalization : []
        }
		const hasPrsnlztn = newPersonalization.find(p => p.p_name === p_name)
        const fprs = !hasPrsnlztn? 
				[...newPersonalization, { p_name: p_name, status: 1 }]
			: 
				newPersonalization;
		if (!hasPrsnlztn) {
			let body = {
				user_id:parseInt(user_id), 
				tool_id:parseInt(tool_id), 
				feature_name: featureName, 
				personalization: fprs
			};
			await rqx.post(`<<global>>/${env()}/personalization/create`, body)
		}
    }

	const showStartHere = () => {
		if (!startHere.data.show || (window.location.pathname !== '/campaign/creative-brief')) return false
		const mode = new URLSearchParams(window.location.search).get("mode")
		const subft = new URLSearchParams(window.location.search).get("subft")
		const allowedURLs = ['product','booking','real-property','training','membership']
		if (mode === 'list' && allowedURLs.includes(subft)) {
			return true
		} else {
			return false
		}
	}

	// useEffect(() => {
	// 	if (toOpenBankForm?.data) return 
	// 	if ((startHere.data?.tasks.length === 0) || !startHere.data?.tasks) return
	// 	const tourName = FeaturesTour(fullURL, selected, showRP, startHere)
	// 	if (!tourName || tourName.done) return
	// 	const prsnlztnName = tourName.p_name
	// 	if (walkthrough.data[prsnlztnName] === false || Object.values(walkthrough.data).some(Boolean)) return
	// 	const startTour = () => {
	// 		walkthrough.set(p => ({ ...p, [tourName.p_name]: true }))
	// 		if (startHere.data?.show) {
	// 			startHere.set(p => ({ ...p, show: false }))
	// 		}
	// 	}
	// 	if (personalization.data?.length === 0 || !personalization.data) {
	// 		startTour()
	// 	} else {
	// 		const has_prsnlztn = personalization.data?.find(p => p.feature_name === tourName.featureName)?.personalization
	// 		if (!has_prsnlztn) {
	// 			startTour()
	// 		} else {
	// 			const p_name = has_prsnlztn?.find(p => p.p_name === prsnlztnName)
	// 			if (p_name) return
	// 			startTour()
	// 		}
	// 	}
	// }, [fullURL, personalization.data, startHere.data, toOpenBankForm.data])
	
	useEffect(() => {
		personalizationRead()
        //eslint-disable-next-line
    }, []);
	
	if (!personalization.data) return null;

	return (
		<>
			{ showStartHere() && <StartHere/> }
			{/* { view === '' && <OnboardingDesktop personalization={personalization} pathname={"/campaign/creative-brief"} end={end} start={start}/> } */}
			{ Boolean(walkthrough.data.creativeBrief) && <CreativeBrief end={end}/>}
			{ Boolean(walkthrough.data.productPromoPage) && <ProductPromoPage end={end}/>}
			{ Boolean(walkthrough.data.setupTraining) && <SetupTraining end={end}/>}
			{ Boolean(walkthrough.data.posterTraining) && <PosterTraining end={end}/>}
			{ Boolean(walkthrough.data.realProperty) && <RealProperty end={end}/>}
			{ Boolean(walkthrough.data.requestedRealProperty) && <RequestedRealProperty end={end}/>}
			{ Boolean(walkthrough.data.callRecording) && <CallRecording end={end}/>}
			{ Boolean(walkthrough.data.contact) && <Contact end={end}/>}
			{ Boolean(walkthrough.data.socialMedia) && <SocialMedia end={end}/>}
			{ Boolean(walkthrough.data.bankDetails) && <BankDetails end={end}/>}
			{ Boolean(walkthrough.data.productReceived) && <ProductReceived end={end}/>}
			{ Boolean(walkthrough.data.productPreparing) && <ProductPreparing end={end}/>}
			{ Boolean(walkthrough.data.productShipped) && <ProductShipped end={end}/>}
			{/* <ProductDelivered end={end}/>
			<ProductConfirmed end={end}/> */}
			{ Boolean(walkthrough.data.salesProduct) && <SalesProduct end={end}/>}
			{/* <ReviewProduct end={end}/> */}
			{ Boolean(walkthrough.data.bookingPromoPage) && <BookingPromoPage end={end}/>} 
			{ Boolean(walkthrough.data.bookingBooked) && <BookingBooked end={end}/>}
			{ Boolean(walkthrough.data.bookingCheckIn) && <BookingCheckIn end={end}/>}
			{/* { Boolean(walkthrough.data.bookingCheckOut) && <BookingCheckOut end={end}/>} */}
			{ Boolean(walkthrough.data.salesBooking) && <SalesBooking end={end}/>}
			{ Boolean(walkthrough.data.salesTraining) && <SalesTraining end={end}/>}
			{ Boolean(walkthrough.data.propertyInquiries) && <PropertyInquiries end={end}/>}
			{/* { Boolean(walkthrough.data.propertyAgentApplications) && <PropertyAgentApplications end={end}/>} */}
			{/* { Boolean(walkthrough.data.reviewProduct) && <ReviewProduct end={end}/>} */}
			{/* { Boolean(walkthrough.data.reviewBooking) && <ReviewBooking end={end}/>} */}
			{ Boolean(walkthrough.data.onboardingSalesProduct) && <OnboardingSalesProduct end={end}/>}
			{ Boolean(walkthrough.data.onboardingSalesBooking) && <OnboardingSalesBooking end={end}/>}
			{ Boolean(walkthrough.data.onboardingSalesRealProperty) && <OnboardingSalesRealProperty end={end}/>}
		</>
	)
}
